
/* global modUtils modForm */
/* This JS file is used to manage callrail functionality */

const callrail = { // eslint-disable-line no-unused-vars
	setCallRailCookie: function(callRailCookieConfig) {
		let cookieString = '';
		let callRailCookieConfigArr = Object.entries(callRailCookieConfig);
		callRailCookieConfigArr = callRailCookieConfigArr.map(function(arrayElement) {
			return arrayElement.join('=');
		});
		cookieString = callRailCookieConfigArr.join('|');
		modUtils.setCookie('qs_track_data' , cookieString);
	},
	init: function(swapJsFilePath) {
		const _this = this;

		if (modUtils.getCookie('qs_track_data') === null) {
			let count = 0;
			const intervalData = setInterval(function() {
				++count;
				if (Object.keys(modForm.opts.quadLinkParams).length > 0 || count === 20) {
					clearInterval(intervalData);
					const params = modUtils.getUrlParamsToObject();
					var PartnerSourceID = (typeof params.PartnerSourceID !== 'undefined') ? params.PartnerSourceID : 0;
					var callRailCookieConfig = {
						'afk': modForm.opts.quadLinkParams.AffiliateKey,
						'clk': modForm.opts.quadLinkParams.CLK,
						'ccid': modForm.opts.quadLinkParams.CCID,
						'qtr': modForm.opts.quadLinkParams.QTR
					};
					if (PartnerSourceID !== 0) {
						callRailCookieConfig.psid = PartnerSourceID;
					}
					_this.setCallRailCookie(callRailCookieConfig);
					modUtils.fetchScript(swapJsFilePath);
				}
			}, 1000);
		} else {
			modUtils.fetchScript(swapJsFilePath);
		}
	}
};
